import type { BrandListItem } from 'src/types';

export const filterWithSearchTerm = (
  brands: BrandListItem[] = [],
  query = '',
) => {
  const lowerCaseTerm = query.toLowerCase().trim();
  if (lowerCaseTerm.length) {
    return brands.filter(
      (b) =>
        b.name.toLowerCase().includes(lowerCaseTerm) ||
        String(b.legacyId).includes(lowerCaseTerm),
    );
  }
  return brands;
};
